<template>
<div class="configOnboardingVue">
    <div class="col-md-10 col-sm-9 u-pad-all-25 c-common-box-shadow u-bg-color-fff">
        <div class="onboarding-presets">

            <h3>
                Onboarding Profiles
                <span class="c-common-btn--inverse-icon-orange">
                    <i class="fa fa-id-card-o" aria-hidden="true"></i>
                </span>
                <a href="javascript: void(0)" @click="openAddProfile()" class="c-common-btn c-common-btn--green">
                    <i class="fa fa-plus" aria-hidden="true"></i> Add Profile
                </a>
            </h3>

            <div class="row">
                <div class="col-md-12 u-margin-20">
                    <div v-if="loading" class="u-padding-all-20">Loading…</div>

                    <div v-else-if="profiles.length === 0" class="u-padding-all-20 text-muted">
                        No onboarding profiles yet. Click <strong>Add Profile</strong> to create one.
                    </div>

                    <div v-else class="panel-group">
                        <div
                            class="panel panel-default o-accordion-area c-common-box-shadow"
                            v-for="(profile, key) in profiles"
                            :key="profile.id || key"
                        >
                            <div class="o-accordion-heading c-common-gradient clearfix">
                                <div class="col-md-7 col-sm-7 u-no-padding">
                                    <span class="ps2 u-padding-all-20">
                                        <a
                                            href="javascript: void(0)"
                                            class="onboarding-default-star"
                                            :class="{ 'is-default': profile.is_default }"
                                            @click="setDefault(profile)"
                                            :title="profile.is_default ? 'Default profile (used by PU current-web onboarding)' : 'Set as default for PU current-web onboarding'"
                                        >
                                            <i :class="profile.is_default ? 'fa fa-star' : 'fa fa-star-o'" aria-hidden="true"></i>
                                        </a>
                                        <strong>{{ profile.description || profile.profile_name || '(unnamed)' }}</strong>
                                        <span v-if="profile.is_default" class="onboarding-default-badge">Default</span>
                                    </span>
                                </div>
                                <div class="col-md-5 col-sm-5 text-right u-padding-all-10">
                                    <label class="o-toggle-inline">
                                        <input type="checkbox" v-model="profile.active" @change="toggleActive(profile)" />
                                        Active
                                    </label>
                                    <a href="javascript: void(0)" class="o-config-edit u-margin-left-10" @click="openEdit(profile)" title="Edit">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                    </a>
                                    <a href="javascript: void(0)" class="u-margin-left-10" @click="deleteProfile(profile)" title="Delete">
                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>

                            <div class="clearfix u-padding-all-20 white-bg">
                                <div class="col-sm-4">
                                    <strong>Active:</strong>
                                    {{ profile.active ? 'Yes' : 'No' }}
                                </div>
                                <div class="col-sm-4">
                                    <strong>Status:</strong>
                                    {{ profile.local_status || '—' }}
                                </div>
                                <div class="col-sm-4">
                                    <strong>Skills:</strong>
                                    {{ (profile.skill_defaults || []).length }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Wide modal — matches the configStatusLevel pattern, but wider for the form's two-column layout -->
    <modal name="onboarding-profile-modal" :width="900" height="auto" :scrollable="true" class="modal-dialog modal-lg">
        <div class="modal-add-call" tabindex="-1" role="dialog">
            <div role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button type="button" class="close custom-modal--close" @click="closeModal()" aria-label="Close">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                        <h1 class="modal-title">{{ editing && editing.id ? 'Edit Profile' : 'Add Profile' }}</h1>
                    </div>

                    <div class="modal-body c-common-box-shadow o-modal-body">

                        <div v-if="saveError" class="onboarding-save-error">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{ saveError }}
                        </div>

                        <!-- ─── Top row: description + status -->
                        <div class="row">
                            <div class="col-sm-7 o-modal-form-field">
                                <label class="common-label-text">Description <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="editing.description" placeholder="e.g. Dock Hire — Local 8" />
                            </div>
                            <div class="col-sm-5 o-modal-form-field">
                                <label class="common-label-text">Preselected List / Status <span class="text-danger">*</span></label>
                                <select class="form-control" v-model="editing.local_status">
                                    <option value="">— select —</option>
                                    <option v-for="s in statusOptions" :key="s.id" :value="s.name">{{ s.name }}</option>
                                </select>
                            </div>
                        </div>

                        <!-- ─── Bare-minimum context strip -->
                        <div class="row u-margin-top-10">
                            <div class="col-sm-12 text-muted">
                                Bare minimum to onboard via this profile — fields the new
                                worker must have or be able to receive in order to finish
                                their record.
                            </div>
                        </div>

                        <!-- ─── Skills + Note side-by-side -->
                        <div class="row u-margin-top-10">
                            <div class="col-sm-7 o-modal-form-field">
                                <label class="common-label-text">Preselected Skills <span class="text-danger">*</span></label>
                                <div class="c-common-box-shadow c-radius3 u-padding-all-10 onboarding-skill-grid">
                                    <div v-if="skillsOptions.length === 0" class="text-muted">Loading skills…</div>
                                    <div v-else class="row">
                                        <div v-for="skill in skillsOptions" :key="skill.id" class="col-sm-4 col-xs-6">
                                            <div class="checkbox o-custom-checkbox clearfix">
                                                <label>
                                                    {{ skill.name }}
                                                    <input type="checkbox" :value="skill.id" v-model="editing.skill_defaults" />
                                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <small class="text-muted">Same skill box as the employee profile.</small>
                            </div>

                            <div class="col-sm-5 o-modal-form-field">
                                <label class="common-label-text">Onboarding Note <span class="text-danger">*</span></label>
                                <textarea class="form-control onboarding-note-area" v-model="editing.onboarding_note" placeholder="Short message included with the SMS / shown on the PWA form."></textarea>
                                <div class="u-margin-top-10">
                                    <label class="common-label-text">Cell <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" disabled value="Always required (SMS destination)" />
                                </div>
                            </div>
                        </div>

                        <!-- ─── Worker detail defaults (optional) -->
                        <div class="row u-margin-top-10">
                            <div class="col-sm-12 text-muted">
                                Optional worker defaults — leave blank unless this profile should preset them.
                            </div>
                        </div>
                        <div class="row u-margin-top-10">
                            <div class="col-sm-4 o-modal-form-field">
                                <label class="common-label-text">Member Since</label>
                                <input type="date" class="form-control" v-model="editing.member_since" />
                            </div>
                            <div class="col-sm-4 o-modal-form-field">
                                <label class="common-label-text">Date of Hire</label>
                                <input type="date" class="form-control" v-model="editing.date_of_hire" />
                            </div>
                            <div class="col-sm-4 o-modal-form-field">
                                <label class="common-label-text">Seniority</label>
                                <input type="number" min="0" step="1" class="form-control" v-model.number="editing.seniority" />
                            </div>
                        </div>

                        <!-- ─── Assigned users (typeahead) -->
                        <div class="row u-margin-top-15">
                            <div class="col-sm-12 o-modal-form-field">
                                <label class="common-label-text">Assigned Users (Stewards, PU, PU-minus)</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="userSearch"
                                    placeholder="Search by name…"
                                    @focus="userSearchFocused = true"
                                    @blur="onSearchBlur"
                                />
                                <div v-if="userSearchFocused && userSearchResults.length > 0" class="onboarding-typeahead c-common-box-shadow">
                                    <div
                                        v-for="u in userSearchResults"
                                        :key="u.id"
                                        class="onboarding-typeahead-row"
                                        @mousedown.prevent="addAssignedUser(u)"
                                    >
                                        <span>{{ assignableLabel(u) }}</span>
                                        <span class="onboarding-role-pill" :class="rolePillClass(u.__role)">{{ u.__role }}</span>
                                    </div>
                                </div>
                                <div v-if="userSearchFocused && userSearch && userSearchResults.length === 0" class="text-muted u-padding-all-10">
                                    No matching steward, PU, or PU-minus user.
                                </div>

                                <div class="onboarding-pills u-margin-top-10">
                                    <span
                                        v-for="u in selectedAssignedUsers"
                                        :key="u.id"
                                        class="onboarding-pill"
                                    >
                                        {{ assignableLabel(u) }}
                                        <span class="onboarding-pill-role" :class="rolePillClass(u.__role)">{{ u.__role }}</span>
                                        <a href="javascript: void(0)" class="onboarding-pill-x" @click="removeAssignedUser(u)" title="Remove">&times;</a>
                                    </span>
                                </div>
                                <small class="text-muted">
                                    Each assigned user gets a "Recruiting" item on their main
                                    menu so they can fire this profile.
                                </small>
                            </div>
                        </div>

                        <!-- ══ #1897 — the bottom half, ordered so it reads as a sequence ══
                             who may start (gates) -> what they receive (link + QR)
                             -> how long it lasts (lifetime) -> is this profile live.
                             ed, 13:19: "rework the bottom half of this form to
                             describe how these factors relate to each other". -->

                        <!-- ─── 1. Who can start: the QR gates (#1827 / #1890) -->
                        <div class="row u-margin-top-15">
                            <div class="col-sm-12 o-modal-form-field">
                                <qr-gates
                                    :profile="editing"
                                    :issued-today="editing.qr_issued_today"
                                    :show-usage="!!editing.id"
                                />
                                <small class="text-muted">
                                    These decide <strong>whether</strong> a scan is allowed to start an
                                    intake. The lifetime below decides <strong>how long</strong> the
                                    session lasts once it has.
                                </small>
                            </div>
                        </div>

                        <!-- ─── 2. What they receive: the public link + QR -->
                        <div class="row u-margin-top-15" v-if="editing.id">
                            <div class="col-sm-7 o-modal-form-field">
                                <label class="common-label-text">Onboarding link</label>
                                <div class="onboarding-link-row">
                                    <input type="text" class="form-control" :value="editing.cs3me_url" readonly data-testid="onboarding-link" />
                                    <a href="javascript: void(0)" class="onboarding-link-action" @click="copyLink()" title="Copy link">
                                        <i class="fa fa-copy" aria-hidden="true"></i>
                                    </a>
                                    <a href="javascript: void(0)" class="onboarding-link-action" @click="refreshLink()" title="Rotate the code">
                                        <i class="fa fa-refresh" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <!-- ⚠ #1897 — ed, 13:4x: "the link delivered under the subdomain is
                                     fine". This is THIS LOCAL'S OWN address, not a cs3.me short link:
                                     YOURLS_API_SIGNATURE is set on no box, so 0 of 21 profiles have
                                     ever minted one and the field used to sit permanently on
                                     "No link yet - click refresh to generate" — a button that could
                                     never do what it promised. The shortener stays in place and
                                     inert; do not present this as un-generated. -->
                                <small class="text-muted">
                                    Public link to the worker onboarding form, on your own address.
                                    <strong>Refresh rotates the code</strong> — the old link stops
                                    resolving immediately, so any QR already printed or posted stops
                                    working. Use it if a link is lost or compromised.
                                </small>
                            </div>
                            <div class="col-sm-5 o-modal-form-field text-center">
                                <label class="common-label-text">QR Code</label>
                                <div class="onboarding-qr-wrap">
                                    <img v-if="editing.qr_url" :src="editing.qr_url" alt="Onboarding QR" class="onboarding-qr-img" ref="qrImage" />
                                    <div v-else class="onboarding-qr-placeholder text-muted">No QR yet</div>
                                </div>
                                <!-- #1897 (ed) — the link beside this has copy + refresh; the QR had
                                     refresh only, so the only way to get the picture out was a
                                     right-click. Copies the IMAGE, because the URL already has its
                                     own copy button one column to the left. -->
                                <a href="javascript: void(0)" class="c-common-btn c-common-btn--small u-margin-top-10"
                                   @click="copyQr()" data-testid="qr-copy">
                                    <i class="fa fa-copy" aria-hidden="true"></i> {{ qrCopyLabel }}
                                </a>
                                <a href="javascript: void(0)" class="c-common-btn c-common-btn--small u-margin-top-10" @click="refreshQr()">
                                    <i class="fa fa-refresh" aria-hidden="true"></i> Refresh QR
                                </a>
                                <!-- ⚠ ACCEPTED, not a defect to fix later: with no shortener the QR
                                     encodes the full subdomain URL, which makes it denser than a
                                     cs3.me one would be. ed accepted that in preferring the
                                     subdomain link. -->
                                <small class="text-muted">Encodes the link on the left.</small>
                            </div>
                        </div>

                        <div class="row u-margin-top-15" v-else>
                            <div class="col-sm-12 text-muted">
                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                Save the profile first to generate the onboarding link and QR.
                            </div>
                        </div>

                        <!-- ─── 3. How long it lasts — #1897, ed 2026-09-12 07:16 EDT:
                             "lets just change the time to 10 min period."

                             THERE IS NO CONTROL HERE ANY MORE, AND THAT IS THE FEATURE.
                             The block that stood here offered Hours + Minutes (where minutes
                             silently won), a live effective-lifetime readout, cap warnings and
                             a governed-channels table — all of it machinery for explaining a
                             setting that no longer exists. A fixed lifetime needs a sentence,
                             not a fieldset.

                             ⚠ Do NOT reintroduce an input here without changing
                             OnboardingLinkService::SESSION_TTL_SECONDS as well: the profile's
                             sms_link_ttl_hours / _minutes columns still EXIST (21 production
                             profiles carry 48) but are out of $fillable and read by nothing,
                             so a field bound to them would save and do absolutely nothing. -->
                        <div class="row u-margin-top-15">
                            <div class="col-sm-12 o-modal-form-field">
                                <p class="text-muted" data-testid="ttl-fixed-note">
                                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                                    Sign-up sessions last <strong>10 minutes</strong>. The link and the
                                    QR share that clock — a scanned QR issues the same kind of session,
                                    on the same timer — and only <strong>one session at a time</strong>
                                    can be open for a given phone number. This is fixed and is the same
                                    for every local.
                                </p>
                            </div>
                        </div>

                        <!-- ─── Active -->
                        <div class="row u-margin-top-15">
                            <div class="col-sm-12 o-modal-form-field">
                                <label class="o-toggle-inline">
                                    <input type="checkbox" v-model="editing.active" /> Active
                                </label>
                            </div>
                        </div>

                    </div>

                    <div class="modal-footer u-no-border">
                        <button type="button" class="c-common-btn" @click="closeModal()" :disabled="saving">Cancel</button>
                        <button type="button" class="c-common-btn c-common-btn--green" @click="saveProfile()" :disabled="!validProfile(editing) || saving">
                            {{ saving ? 'Saving…' : 'Save' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import service from '../../services.js';
// #1890 — the QR gates live in ONE component, shared with the standalone
// profiles screen. Two copies of a consent-and-limits control would drift, and
// the copy that drifts is the one nobody is looking at.
import QrGates from '../onboarding/qrGates.vue';
import { clampCap } from '../../qrGateRules.js';
// #1897 — linkTtl.js is GONE with the controls it explained. The lifetime is
// OnboardingLinkService::SESSION_TTL_SECONDS (10 minutes) and the form no longer
// has a say in it, so there is nothing left for the front end to compute.

/**
 * #1890 — the QR gate fields, but only when the source object has them.
 *
 * See the note at the call site: the API rules are all `sometimes`, so omitting
 * a key preserves the stored value while sending a coerced `false` overwrites
 * it.
 */
function qrPayloadIfPresent(p) {
    if (!p || p.qr_enabled === undefined) {
        return {};
    }

    return {
        qr_enabled: !!p.qr_enabled,
        qr_active_until: p.qr_active_until || null,
        qr_daily_cap: clampCap(p.qr_daily_cap),
        qr_require_sms_verify: !!p.qr_require_sms_verify,
    };
}

// Onboarding profile CRUD endpoints (to be implemented in v3):
//   GET    /api/v3/onboarding/profiles
//   POST   /api/v3/onboarding/profiles
//   PUT    /api/v3/onboarding/profiles/:id
//   DELETE /api/v3/onboarding/profiles/:id
//   PUT    /api/v3/onboarding/profiles/:id/users  (assigned_user_ids replace-set)
//   POST   /api/v3/onboarding/profiles/:id/link/refresh  → { cs3me_url }
//   POST   /api/v3/onboarding/profiles/:id/qr/refresh    → { qr_url }
//
// On worker onboarding completion, backend MUST persist
// profile.onboarding_note as a Note on the new employee profile so it
// shows up in the employee record. (notes table; notable_type=Employee)
//
// Lookups reused:
//   skill/getAllSkills              → preselected skills
//   employee/employee_status        → list / status options
//   employee/getStewards            → assigned-users source (steward skill)
//   employee/getPowerUsers          → assigned-users source (PU role)
//   employee/getPowerUserMinusUsers → assigned-users source (PU-minus role)

export default {
    components: { QrGates },
    props: {
        empDetails: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            loading: false,
            profiles: [],
            editing: this.emptyProfile(),
            // #1897 — the QR copy control reports which of the two things it
            // managed to put on the clipboard, because they are not equivalent.
            qrCopyLabel: 'Copy QR',
            skillsOptions: [],
            statusOptions: [],
            // Unified pool of assignable users (steward + PU + PU-minus). Each entry has
            // a __role tag ('steward' | 'PU' | 'PU-') for the search-result pill.
            assignableUsers: [],
            userSearch: '',
            userSearchFocused: false,
            saving: false,
            saveError: '',
        };
    },
    computed: {
        ...mapGetters({
            userToken: 'userToken',
            userRole: 'userRole',
            userClientID: 'userClientID',
        }),
        userSearchResults() {
            const q = (this.userSearch || '').trim().toLowerCase();
            const selectedIds = new Set(this.editing.assigned_user_ids || []);
            const remaining = this.assignableUsers.filter(u => !selectedIds.has(u.id));
            if (!q) return remaining.slice(0, 8);
            return remaining
                .filter(u => this.assignableLabel(u).toLowerCase().includes(q)
                    || (u.__role && u.__role.toLowerCase().includes(q)))
                .slice(0, 12);
        },
        selectedAssignedUsers() {
            const ids = this.editing.assigned_user_ids || [];
            return ids
                .map(id => this.assignableUsers.find(u => u.id === id))
                .filter(Boolean);
        },
    },
    methods: {
        emptyProfile() {
            return {
                id: null,
                description: '',
                requires_cell: true,
                skill_defaults: [],
                local_status: '',
                onboarding_note: '',
                member_since: null,
                date_of_hire: null,
                seniority: null,
                active: true,
                assigned_user_ids: [],
                cs3me_url: '',
                qr_url: '',
                is_default: false,
                // #1890 — present on the blank profile so the controls are
                // reactive on Add. On Edit the API row supplies the real values.
                qr_enabled: false,
                qr_active_until: null,
                qr_daily_cap: 0,
                qr_require_sms_verify: false,
                qr_issued_today: null,
            };
        },
        validProfile(p) {
            return !!p.description
                && Array.isArray(p.skill_defaults) && p.skill_defaults.length > 0
                && !!p.local_status
                && !!p.onboarding_note;
        },
        formatDate(d) {
            try { return new Date(d).toLocaleString(); }
            catch (e) { return d; }
        },
        // URL-safe slug derived from the description — the backend
        // requires a unique alpha_dash slug per tenant.
        slugify(s) {
            return (s || '').toString().trim().toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/(^-+|-+$)/g, '')
                .slice(0, 80);
        },
        // Build the body the /onboarding/profiles API expects from a
        // profile object — used by create, edit, and the inline
        // active / default toggles.
        profilePayload(p) {
            const desc = (p.description || p.profile_name || '').trim();
            const numOrNull = (v) => (v === '' || v === null || v === undefined) ? null : Number(v);
            return {
                profile_name:    p.profile_name || desc,
                slug:            p.slug || this.slugify(desc),
                description:     desc,
                local_status:    p.local_status,
                skill_defaults:  p.skill_defaults || [],
                onboarding_note: p.onboarding_note,
                active:          !!p.active,
                is_default:      !!p.is_default,
                member_since:    p.member_since || null,
                date_of_hire:    p.date_of_hire || null,
                seniority:       numOrNull(p.seniority),
                // #1897 — sms_link_ttl_hours / _minutes are no longer read into
                // the form, and therefore no longer sent back on save. The
                // lifetime is fixed at OnboardingLinkService::SESSION_TTL_SECONDS.
                // Not loading them is what keeps the stored 48 INERT: bind them
                // to nothing and the admin cannot round-trip a value that the
                // server has stopped honouring.
                assigned_user_ids: Array.isArray(p.assigned_user_ids) ? p.assigned_user_ids : [],
                // #1890 — the four gates from #1827.
                //
                // ⚠ ONLY WHEN THE OBJECT ACTUALLY CARRIES THEM. Every rule on
                // the API side is `sometimes`, so an absent key leaves the
                // stored value alone — but a key sent as `!!undefined` would
                // write `false`. This payload is also built by the inline
                // Active and Default toggles from a list row, and quietly
                // turning someone's QR off while they flipped Active is exactly
                // the kind of silent write this codebase keeps getting bitten
                // by.
                ...qrPayloadIfPresent(p),
            };
        },
        // Turn an axios error into a human sentence. A 403 here almost
        // always means the tenant could not be resolved from the host.
        describeError(e, verb) {
            const res = e && e.response;
            const errs = res && res.data && res.data.errors;
            if (errs) {
                return 'Could not ' + verb + ': ' + Object.values(errs).flat().join('; ');
            }
            if (res && res.status === 403) {
                return 'Blocked (403) — could not resolve the tenant from this address. '
                    + 'Open the app on the tenant subdomain and try again.';
            }
            if (res && res.status) {
                const msg = res.data && res.data.error;
                return 'Failed (HTTP ' + res.status + ')' + (msg ? ': ' + msg : '') + '.';
            }
            return 'Network error — please check your connection and try again.';
        },
        /**
         * #1897 (ed) — copy the QR IMAGE, not its URL.
         *
         * The link beside it already has its own copy button, so the URL is one
         * click away; what an admin wants out of this block is the picture, for
         * an email or a poster. Until now the only way to get it was a
         * right-click.
         *
         * ⚠ `ClipboardItem` is not everywhere, and image copy needs a secure
         * context. The fallback copies the URL — which is a DIFFERENT thing to
         * paste, so the label has to say which one happened rather than claim
         * success either way.
         */
        async copyQr() {
            const src = this.editing.qr_url;
            if (!src) {
                return;
            }

            try {
                if (typeof ClipboardItem === 'undefined' || !navigator.clipboard || !navigator.clipboard.write) {
                    throw new Error('no ClipboardItem');
                }
                const blob = await (await fetch(src)).blob();
                await navigator.clipboard.write([new ClipboardItem({ [blob.type || 'image/png']: blob })]);
                this.flashQrCopy('Image copied');
            } catch (e) {
                try {
                    await navigator.clipboard.writeText(this.editing.cs3me_url || src);
                    this.flashQrCopy('Link copied instead');
                } catch (e2) {
                    this.flashQrCopy('Copy failed');
                }
            }
        },
        flashQrCopy(label) {
            this.qrCopyLabel = label;
            setTimeout(() => { this.qrCopyLabel = 'Copy QR'; }, 2500);
        },
        openAddProfile() {
            this.editing = this.emptyProfile();
            this.userSearch = '';
            this.saveError = '';
            this.$modal.show('onboarding-profile-modal');
        },
        openEdit(profile) {
            this.editing = Object.assign(this.emptyProfile(), JSON.parse(JSON.stringify(profile)));
            this.userSearch = '';
            this.saveError = '';
            this.$modal.show('onboarding-profile-modal');
        },
        closeModal() {
            this.$modal.hide('onboarding-profile-modal');
        },
        async saveProfile() {
            if (!this.validProfile(this.editing) || this.saving) return;
            this.saveError = '';
            const payload = this.profilePayload(this.editing);
            if (!payload.slug) {
                this.saveError = 'The description needs letters or numbers — it is used to build the link slug.';
                return;
            }
            this.saving = true;
            try {
                if (this.editing.id) {
                    await service.putUrl('/api/v3/onboarding/profiles/' + this.editing.id, payload);
                } else {
                    await service.postUrl('/api/v3/onboarding/profiles', payload);
                }
                this.closeModal();
                await this.loadProfiles();
            } catch (e) {
                this.saveError = this.describeError(e, 'save');
            } finally {
                this.saving = false;
            }
        },
        toggleActive(profile) {
            // profile.active was just flipped by the checkbox v-model.
            service.putUrl('/api/v3/onboarding/profiles/' + profile.id, this.profilePayload(profile))
                .catch((e) => {
                    profile.active = !profile.active; // revert the optimistic flip
                    alert(this.describeError(e, 'update'));
                });
        },
        setDefault(profile) {
            if (profile.is_default) return;
            const body = Object.assign(this.profilePayload(profile), { is_default: true });
            service.putUrl('/api/v3/onboarding/profiles/' + profile.id, body)
                .then(() => this.loadProfiles())
                .catch((e) => alert(this.describeError(e, 'update')));
        },
        deleteProfile(profile) {
            if (!confirm('Delete onboarding profile "' + (profile.description || profile.profile_name) + '"?')) return;
            service.delUrl('/api/v3/onboarding/profiles/' + profile.id)
                .then(() => this.loadProfiles())
                .catch((e) => {
                    const code = e && e.response && e.response.data && e.response.data.error;
                    alert(code === 'cannot_delete_default'
                        ? 'Cannot delete the default profile — set another profile as default first.'
                        : this.describeError(e, 'delete'));
                });
        },
        assignableLabel(u) {
            const inner = u && (u.employable || u.user) || {};
            const name = [inner.first_name || u.first_name, inner.last_name || u.last_name]
                .filter(Boolean)
                .join(' ');
            return name || u.name || u.id;
        },
        rolePillClass(role) {
            if (role === 'steward') return 'role-pill-steward';
            if (role === 'PU') return 'role-pill-pu';
            if (role === 'PU-') return 'role-pill-puminus';
            return '';
        },
        addAssignedUser(u) {
            if (!this.editing.assigned_user_ids) this.editing.assigned_user_ids = [];
            if (!this.editing.assigned_user_ids.includes(u.id)) {
                this.editing.assigned_user_ids.push(u.id);
            }
            this.userSearch = '';
        },
        removeAssignedUser(u) {
            this.editing.assigned_user_ids = (this.editing.assigned_user_ids || []).filter(id => id !== u.id);
        },
        onSearchBlur() {
            // Slight defer so click on a row registers via mousedown before close.
            setTimeout(() => { this.userSearchFocused = false; }, 120);
        },

        copyLink() {
            const url = this.editing.cs3me_url;
            if (!url) return;
            try {
                navigator.clipboard.writeText(url);
            } catch (e) {
                // fallback
                const el = document.createElement('textarea');
                el.value = url;
                document.body.appendChild(el);
                el.select();
                try { document.execCommand('copy'); } catch (ee) { /* ignore */ }
                document.body.removeChild(el);
            }
        },
        refreshLink() {
            if (!this.editing.id) return;
            if (this.editing.cs3me_url && !confirm('Refresh the cs3.me link? The old link will stop working immediately.')) return;
            service.postUrl('/api/v3/onboarding/profiles/' + this.editing.id + '/link/refresh', {})
                .then((res) => {
                    const data = (res && res.data && res.data.data) || {};
                    // $set ensures reactivity even if the editing object
                    // didn't have these fields tracked from initial load.
                    this.$set(this.editing, 'cs3me_url', data.cs3me_url || '');
                    // The QR encodes the cs3me_url, so a rotated short_code
                    // invalidates the old PNG too — clear it; admin can hit
                    // "Refresh QR" to render the new one.
                    this.$set(this.editing, 'qr_url', '');
                })
                .catch((err) => {
                    const msg = (err && err.response && err.response.data && err.response.data.error) || 'Failed to refresh link.';
                    alert(msg);
                });
        },
        refreshQr() {
            if (!this.editing.id) return;
            if (this.editing.qr_url && !confirm('Refresh the QR code? Posted/printed copies will stop working.')) return;
            service.postUrl('/api/v3/onboarding/profiles/' + this.editing.id + '/qr/refresh', {})
                .then((res) => {
                    const data = (res && res.data && res.data.data) || {};
                    this.$set(this.editing, 'qr_url', data.qr_url || '');
                })
                .catch((err) => {
                    const msg = (err && err.response && err.response.data && err.response.data.error) || 'Failed to refresh QR code.';
                    alert(msg);
                });
        },

        loadProfiles() {
            this.loading = true;
            return service.getUrl('/api/v3/onboarding/profiles')
                .then((res) => { this.profiles = (res && res.data && res.data.data) || []; })
                .catch(() => { this.profiles = []; })
                .finally(() => { this.loading = false; });
        },
        authHeaders() {
            return {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID,
            };
        },
        loadSkills() {
            service.get('skill/getAllSkills', this.authHeaders())
                .then((res) => { this.skillsOptions = res.data.result || []; })
                .catch((err) => { console.warn('skills load failed', err); });
        },
        loadStatuses() {
            service.get('employee/employee_status', this.authHeaders())
                .then((res) => { this.statusOptions = res.data.result || []; })
                .catch((err) => { console.warn('statuses load failed', err); });
        },
        loadAssignableUsers() {
            // Stewards
            const stewards = service.get('employee/getStewards', this.authHeaders())
                .then((res) => (res.data.result || []).map(u => ({ ...u, __role: 'steward' })))
                .catch(() => []);
            // Power-users
            const pus = service.get('employee/getPowerUsers', this.authHeaders())
                .then((res) => (res.data.result || []).map(u => ({ ...u, __role: 'PU' })))
                .catch(() => []);
            // PU-minus
            const pums = service.get('employee/getPowerUserMinusUsers', this.authHeaders())
                .then((res) => (res.data.result || []).map(u => ({ ...u, __role: 'PU-' })))
                .catch(() => []);

            Promise.all([stewards, pus, pums]).then((groups) => {
                const merged = [];
                const seen = new Set();
                groups.flat().forEach((u) => {
                    if (!u || !u.id || seen.has(u.id)) return;
                    seen.add(u.id);
                    merged.push(u);
                });
                this.assignableUsers = merged;
            });
        },
    },
    mounted() {
        this.loadProfiles();
        this.loadSkills();
        this.loadStatuses();
        this.loadAssignableUsers();
    },
};
</script>

<style scoped>
.o-toggle-inline {
    display: inline-block;
    margin-right: 8px;
    font-weight: normal;
}
.u-margin-left-10 { margin-left: 10px; }
.u-margin-bottom-10 { margin-bottom: 10px; }
.u-margin-top-10 { margin-top: 10px; }
.u-margin-top-15 { margin-top: 15px; }
.u-no-border { border: 0; }
.text-muted { color: #888; }
.text-danger { color: #c0392b; }

.onboarding-save-error {
    background: #fdf2f1;
    border: 1px solid #e6b0aa;
    color: #c0392b;
    border-radius: 4px;
    padding: 8px 12px;
    margin-bottom: 12px;
}

.onboarding-skill-grid { max-height: 240px; overflow-y: auto; }
.onboarding-note-area { min-height: 120px; }

.onboarding-typeahead {
    position: relative;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin-top: -1px;
    max-height: 220px;
    overflow-y: auto;
    z-index: 10;
}
.onboarding-typeahead-row {
    padding: 6px 10px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.onboarding-typeahead-row:hover { background: #f4f7fa; }

.onboarding-pill {
    display: inline-flex;
    align-items: center;
    background: #eef3f7;
    border: 1px solid #d2dde6;
    border-radius: 16px;
    padding: 3px 10px;
    margin: 4px 6px 4px 0;
    font-size: 0.92em;
}
.onboarding-pill-x {
    margin-left: 8px;
    color: #888;
    font-size: 1.2em;
    line-height: 1;
}
.onboarding-pill-x:hover { color: #c0392b; text-decoration: none; }

.onboarding-role-pill,
.onboarding-pill-role {
    display: inline-block;
    margin-left: 8px;
    font-size: 0.78em;
    padding: 1px 7px;
    border-radius: 8px;
    background: #ddd;
    color: #333;
}
.role-pill-steward { background: #d4edda; color: #155724; }
.role-pill-pu      { background: #d1ecf1; color: #0c5460; }
.role-pill-puminus { background: #fff3cd; color: #856404; }

.onboarding-link-row {
    display: flex;
    align-items: center;
    gap: 6px;
}
.onboarding-link-row .form-control { flex: 1; }
.onboarding-link-action {
    display: inline-block;
    padding: 6px 10px;
    color: #555;
    border: 1px solid #d2dde6;
    border-radius: 3px;
    background: #fff;
}
.onboarding-link-action:hover { color: #2c3e50; background: #f4f7fa; text-decoration: none; }

.onboarding-qr-wrap {
    border: 1px dashed #ccc;
    border-radius: 6px;
    padding: 8px;
    display: inline-block;
    background: #fafafa;
}
.onboarding-qr-img {
    width: 140px;
    height: 140px;
    image-rendering: pixelated;
    display: block;
}
.onboarding-qr-placeholder {
    width: 140px;
    height: 140px;
    line-height: 140px;
}

.onboarding-default-star {
    color: #c9c9c9;
    margin-right: 8px;
    font-size: 1.05em;
}
.onboarding-default-star.is-default { color: #f0a800; }
.onboarding-default-star:hover { color: #f0a800; text-decoration: none; }

.onboarding-default-badge {
    display: inline-block;
    margin-left: 8px;
    font-size: 0.78em;
    padding: 1px 8px;
    border-radius: 8px;
    background: #fff3cd;
    color: #856404;
}
</style>
